export const SEAHORSE_PORTAL_BUILD_NO = 1699276165327;
